module.exports = {
	"Pro": {
		"features": [
			{
				"text": "Unlimited documents/month",
				"image": "unlimited-documents.svg"
			},
			{
				"text": "HelloSign integrations (Gmail, Box, etc.)",
				"image": "Google_integration_icon.svg"
			},
			{
				"text": "Time-stamped audit trail",
				"image": "clock_icon.svg"
			},
			{
				"text": "Data validation",
				"image": "Data_validation_icon.svg"
			},
			{
				"text": "1 template",
				"image": "reusable_templates.svg"
			},
			{
				"text": "Bank Level Security",
				"image": "lock_number2.svg"
			}
		]
	},
	"Business": {
		"features": [
			{
				"text": "Custom branding for your documents",
				"image": "megaphone.svg"
			},
			{
				"text": "In-person signing",
				"image": "inperson_icon.svg"
			},
			{
				"text": "Team features like transaction overviews",
				"image": "teams_icon.svg"
			},
			{
				"text": "Unlimited documents/month",
				"image": "unlimited-documents.svg"
			},
			{
				"text": "5 senders",
				"image": "send_icon_2.svg"
			},
			{
				"text": "5 templates",
				"image": "reusable_templates.svg"
			},
			{
				"text": "Bank Level Security",
				"image": "lock_number2.svg"
			}
		]
	},
	"Business 10": {
		"features": [
			{
				"text": "Custom branding for your documents",
				"image": "megaphone.svg"
			},
			{
				"text": "In-person signing",
				"image": "inperson_icon.svg"
			},
			{
				"text": "Team features like transaction overviews",
				"image": "teams_icon.svg"
			},
			{
				"text": "Unlimited documents/month",
				"image": "unlimited-documents.svg"
			},
			{
				"text": "10 senders",
				"image": "send_icon_2.svg"
			},
			{
				"text": "10 templates",
				"image": "reusable_templates.svg"
			},
			{
				"text": "Bank Level Security",
				"image": "lock_number2.svg"
			}
		]
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/data/plan-features-map.json
 ** module id = 1102
 ** module chunks = 0
 **/